import React from 'react';
// Constants
import { CompanyName } from '../../utils/Constants';
// Icons
// Data
import {
  dominationGalleryAdditionalMeta,
  dominationGalleryStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import FooterComponent from '../../components/footer/FooterComponent';
import DominationGalleryMainContainer from '../../components/galleries/DominationGalleryMainContainer';
import { HelmetItem } from '../../components/utils/HelmetItem';
import AltHeader from '../../components/general/AltHeader';
import HeaderBanner from '../../components/general/HeaderBanner';

function DominationGallery() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Domination Gallery'
        desc={`Step into the world of ${CompanyName} and explore a powerful visual journey through her most commanding moments. This gallery showcases the raw elegance, seductive control, and undeniable dominance of Mistress Maria.`}
        keywords={`Mistress Maria, Domination Gallery, Femdom Photography, Power Exchange, Female Dominance, BDSM, Domme Portfolio`}
        additionalMeta={dominationGalleryAdditionalMeta}
        structuredData={dominationGalleryStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins invisible_scrollbar'>
        <div className='grid h-fit'>
          {/* Alt */}
          <AltHeader />

          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='grid pt-12'>
            <HeaderBanner message={'Domination Gallery'} />
          </header>
        </div>

        {/* Main page content */}
        <DominationGalleryMainContainer />

        {/* Footer */}
        <FooterComponent />
      </div>
    </>
  );
}

export default DominationGallery;
